"use client";

import { cn } from "@/lib/tailwind";
import { useEffect, useState } from "react";

interface IProps {
  activeStep: number;
  steps: string[];
  inactiveBgColor?: string;
  inactiveTextColor?: string;
  className?: string;
}

export const Stepper = ({ activeStep, steps, inactiveBgColor = 'bg-tertiary-8', className, inactiveTextColor }: IProps) => {
  // states
  const [activeIdx, setActiveIdx] = useState(0);

  // methods
  function getStepperTitlePos(idx: number) {
    if (idx === 0) return "left-0";
    if (idx === steps.length - 1) return "right-0";
    return "left-1/2 -translate-x-1/2";
  }

  // effects
  useEffect(() => {
    setActiveIdx(activeStep);
  }, [activeStep]);

  return (
    <div className={`flex items-center ${className}`}>
      {steps.map((step, idx) => (
        <div key={idx} className={cn("flex items-center", idx === 0 ? "" : "flex-1")}>
          {idx === 0 ? (
            <></>
          ) : (
            <div
              className={cn(
                "flex-1",
                activeIdx >= idx ? "h-[3px] bg-black" : `h-[1px] ${inactiveBgColor}`,
              )}
            ></div>
          )}
          <div
            className={cn(
              "relative rounded-full",
              activeIdx >= idx ? "h-[13px] w-[13px] bg-black" : `h-[11px] w-[11px] ${inactiveBgColor}`,
            )}
          >
            <p className={cn("absolute top-6 whitespace-nowrap text-xs", getStepperTitlePos(idx), activeIdx >= idx ? `text-black` : `text-tertiary-8 ${inactiveTextColor}`)}>
              {step}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
